import type { AdditionalQuestionsConfig } from "../../types";

/**
 * validates additional questions specifically since they are dynamically added and don't always have the same fieldnames
 *
 */
export const validateAdditionalQuestions = (
  responses: any,
  additionalQuestionsConfig: AdditionalQuestionsConfig
): Record<string, string> | null => {
  const errors: Record<string, string> = {};

  additionalQuestionsConfig?.questions?.forEach((question) => {
    const response = responses[question?.id];
    const error = validateSingleQuestion(response, question);
    if (error) {
      errors[question?.id] = error;
    }
  });
  return Object.keys(errors).length > 0 ? errors : null;
};

export const validateSingleQuestion = (
  value: any,
  questionConfig: any
): string | null => {
  if (
    questionConfig?.isRequired &&
    (value === null || value === undefined || value === "")
  ) {
    return "This field is required";
  }
  //Will need to add a case for choice when we add choice options to additional questions

  return null;
};
